import { useEffect, useState } from 'react';

export interface ImageNaturalSize {
  width: number;
  height: number;
}

/**
 * Resolves the natural (intrinsic) pixel dimensions of an image source.
 *
 * The browser caches the request, so loading the same `src` from multiple
 * crops is a single network fetch.
 */
export function useImageNaturalSize(src?: string): ImageNaturalSize | null {
  const [size, setSize] = useState<ImageNaturalSize | null>(null);

  useEffect(() => {
    if (!src) {
      setSize(null);
      return;
    }

    let active = true;
    const image = new Image();
    image.onload = () => {
      if (active) {
        setSize({ width: image.naturalWidth, height: image.naturalHeight });
      }
    };
    image.src = src;

    return () => {
      active = false;
    };
  }, [src]);

  return size;
}
